import { create } from 'zustand';
import { queryClient } from '../config/queryClient';

// Tokens stored in memory only — NOT persisted to localStorage.
// This prevents XSS-based token theft.
export const useAuthStore = create(
  (set) => ({
    user: null,
    accessToken: null,
    isAuthenticated: false,
    isInitializing: true,

    setAuth: (user, accessToken) =>
      set({ user, accessToken, isAuthenticated: true }),

    setAccessToken: (accessToken) =>
      set({ accessToken }),

    setUser: (user) => set({ user }),

    setInitializing: (value) => set({ isInitializing: value }),

    // Query keys (e.g. ['referrals', ...]) aren't scoped by user/doctor id, so without this,
    // a subsequent login in the same browser tab could serve the previous user's cached data.
    logout: () => {
      queryClient.clear();
      set({ user: null, accessToken: null, isAuthenticated: false });
    },
  })
);